import React, { Component } from 'react'
import PropTypes from 'prop-types'

class FundHeaderSubNav extends Component {
  constructor(props) {
    super(props)

    const { navFields } = this.props

    this.state = {
      value: 'overview',
      subNavItems: this.getSubNavItems(navFields),
    }

    this.headerHeight = 518
    this.mobileHeaderHeight = 18
    this.jumpScrollInitialLimit = 195
  }

  getSubNavItems = (navFields) => {
    const subNavItems = [
      {
        id: 'overview',
        name: 'Overview',
        isVisible: !navFields.hideOverview,
      },
      {
        id: 'performance',
        name: 'Performance',
        isVisible: !navFields.hidePerformance,
      },
      {
        id: 'ratings-risk',
        name: 'Ratings & Risk',
        isVisible: !navFields.hideRatingsAndRisk,
      },
      {
        id: 'fees-expenses',
        name: 'Fees & Expenses',
        isVisible: !navFields.hideFeesAndExpenses,
      },
      {
        id: 'portfolio-details',
        name: 'Portfolio',
        isVisible: !navFields.hidePortfolio,
      },
      {
        id: 'capital-gains',
        name: 'Capital Gains & Dividends',
        isVisible: !navFields.hideCapitalGains,
      },
      {
        id: 'literature',
        name: 'Literature',
        isVisible: !navFields.hideLiterature,
      },
      {
        id: 'similar',
        name: 'Related Products',
        isVisible: !navFields.hideRelatedProducts,
      },
    ]
    return subNavItems
  }

  componentDidMount = () => {
    window.addEventListener('scroll', this.highlightSubNavOnScroll, false)
  }

  UNSAFE_componentWillReceiveProps = () => {
    const { navFields } = this.props
    this.setState({
      subNavItems: this.getSubNavItems(navFields),
    })
  }

  handleChange = (event) => {
    this.setState(
      {
        value: event.target.value,
      },
      () => this.mobileScrollToSection(this.state.value)
    )
  }

  calculateHeaderHeight = () => {
    let headerHeight = null

    const header = document.querySelector('header')
    const navElement = document.querySelector('nav')
    const brandMessage = document.querySelector('#brand-message')
    const fundHeader = document.querySelector('#fund-header')

    const headerRect = header.getBoundingClientRect()
    const navElementRect = navElement.getBoundingClientRect()
    const brandMessageRect = brandMessage.getBoundingClientRect()
    const fundHeaderRect = fundHeader.getBoundingClientRect()

    headerHeight =
      headerRect.height +
      navElementRect.height +
      brandMessageRect.height +
      fundHeaderRect.height

    return headerHeight
  }

  dispatchJumpScroll = () => {
    const event = new Event('jumpScroll')

    window.dispatchEvent(event)
  }

  mobileScrollToSection = (sectionValue) => {
    this.dispatchJumpScroll()

    const element = document.querySelector('#' + sectionValue)

    window.scrollTo({
      left: 0,
      top: element ? this.defineSectionTop(element, 'Dropdown-menu') : 0,
      behavior: 'smooth',
    })
  }

  renderSubNavItems = () => {
    return this.state.subNavItems.map((subNavItem) => {
      if (subNavItem.isVisible) {
        return (
          <li
            key={subNavItem.id}
            id={'subNavItem' + subNavItem.id}
            className="List-item"
            data-section-content={subNavItem.id}
            onClick={this.scrollToSection}
          >
            {subNavItem.name}
          </li>
        )
      }
    })
  }

  renderMobileSubNavItems = () => {
    return this.state.subNavItems.map((subNavItem) => {
      if (subNavItem.isVisible) {
        return (
          <option key={subNavItem.id} value={subNavItem.id}>
            {subNavItem.name}
          </option>
        )
      }
    })
  }

  defineSectionTop = (element, eventType) => {
    const rect = element.getBoundingClientRect()
    let headerHeight = null

    if (eventType === 'List-item') {
      headerHeight = this.headerHeight
    } else {
      headerHeight = this.mobileHeaderHeight
    }

    const formula =
      window.pageYOffset +
      (rect.top +
        (window.pageYOffset > this.jumpScrollInitialLimit ? 300 : 160)) -
      (headerHeight + (window.pageYOffset > 220 ? 80 : 0))

    return formula
  }

  removeSelectedState = (parent) => {
    parent.children.forEach((child) => {
      child.classList.remove('is-selected')
    })
  }

  highlightNav = (menuElement) => {
    let target

    if (menuElement.classList.contains('List-item')) {
      this.removeSelectedState(menuElement.parentElement)

      target = menuElement
    } else {
      this.removeSelectedState(menuElement.parentElement.parentElement)

      target = menuElement.parentElement
    }

    target.classList.add('is-selected')
  }

  scrollToSection = (e) => {
    this.dispatchJumpScroll()

    this.highlightNav(e.target)

    const element = document.querySelector(
      '#' + e.target.dataset.sectionContent
    )

    const top = element ? this.defineSectionTop(element, 'List-item') : 0

    window.scrollTo({
      left: 0,
      top: top,
      behavior: 'smooth',
    })
  }

  highlightSubNavOnScroll = () => {
    const pageYOffset = window.pageYOffset

    this.state.subNavItems.forEach((subNavItem) => {
      if (subNavItem.isVisible) {
        const element = document.querySelector('#' + subNavItem.id)
        const formula = element
          ? this.defineSectionTop(element, 'List-item') - 25
          : 0

        if (pageYOffset > formula) {
          this.highlightNav(
            document.querySelector('#' + 'subNavItem' + subNavItem.id)
          )
        }
      }
    })
  }

  render = () => {
    return (
      <div className="u-bgColorBrandLight">
        <ul
          className="List List--inline List--selectable List--reversed u-sizeConstrained u-sm-hidden"
          id="fundHeader-subNav"
        >
          {this.renderSubNavItems()}
        </ul>

        <div className="u-hidden u-paddingVert4gu u-sizeConstrained u-sm-block">
          <div
            className="Dropdown Dropdown--reversed"
            id="js-fundHeader-dropdown"
          >
            <select
              id="fund-header-subnav-dropdown"
              className="Dropdown-menu"
              value={this.state.value}
              onChange={this.handleChange}
            >
              {this.renderMobileSubNavItems()}
            </select>
          </div>
        </div>
      </div>
    )
  }
}

FundHeaderSubNav.propTypes = {
  navFields: PropTypes.object.isRequired,
}

export default FundHeaderSubNav
